import { grey } from '@material-ui/core/colors'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class Instruction extends Component {
  render() {
    const text = this.props.text.length
      ? `<span style="text-decoration: underline;">${this.props.text}</span>`
      : `😊 Wait for the experimenter to start.<br /><br />
        Follow the instructions to select the text using our method. Once the correct text is selected, you will receive the next trial.<br /><br />
        Select as fast and accurate as possible.<br /><br />
        There will be a total of 2 blocks each consisting of 30 trials and 10 training trials. You may take a short break after each block.
        Please let the experimenter know if you have any questions.`
    return (
      <p
        style={{
          lineHeight: '170%',
          color: grey[600],
          marginBottom: '2rem',
          // pointerEvents: 'none',
        }}
        dangerouslySetInnerHTML={{
          __html: text,
        }}
        // onClick={() => {
        //   window.document.body.requestFullscreen().catch(console.error)
        // }}
      ></p>
    )
  }
}

Instruction.propTypes = {
  text: PropTypes.string,
}
